import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Clock, ArrowUpRight } from "lucide-react";

const CATEGORY_LABEL = { articulo: "Artículo", cronica: "Crónica" };

export const ArticleCard = ({ article, big = false }) => {
  const words = (article.content || "").split(/\s+/).length;
  const readMin = Math.max(2, Math.round(words / 210));
  return (
    <Link
      to={`/articulo/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-edge bg-ink3 transition-colors duration-300 hover:border-crimson/60"
    >
      <div className={`relative overflow-hidden ${big ? "aspect-[16/9]" : "aspect-[16/10]"}`}>
        <img
          src={article.cover_image}
          alt={article.title}
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink3 via-transparent to-transparent" />
        <span className="absolute left-4 top-4 rounded-full bg-crimson px-3 py-1 font-mono-score text-[10px] font-bold uppercase tracking-[0.2em] text-white">
          {CATEGORY_LABEL[article.category] || "Artículo"}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-3 p-5 md:p-6">
        <h3
          className={`font-display font-bold uppercase leading-tight text-white ${
            big ? "text-2xl md:text-3xl" : "text-xl"
          }`}
        >
          {article.title}
        </h3>
        <p className="line-clamp-3 text-sm leading-relaxed text-slate-400">{article.excerpt}</p>
        <div className="mt-auto flex items-center justify-between pt-2">
          <div className="flex items-center gap-3 font-mono-score text-[11px] uppercase tracking-widest text-slate-500">
            <span className="text-crimson">@ENOLFC</span>
            <span className="flex items-center gap-1">
              <Clock className="h-3 w-3" /> {readMin} min
            </span>
          </div>
          <motion.span className="flex h-8 w-8 items-center justify-center rounded-full border border-edge text-slate-400 transition-colors group-hover:border-crimson group-hover:bg-crimson group-hover:text-white">
            <ArrowUpRight className="h-4 w-4" />
          </motion.span>
        </div>
      </div>
    </Link>
  );
};

export default ArticleCard;
